import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { buscarCategoriasDeProdutos, cadastrarOutrosProdutos, cadastrarFuncionario } from '../../services/api';

// css
import 'bootstrap/dist/css/bootstrap.min.css';
import "./FormCadastrarOutrosProdutos.css";
import '../../styles/global.css';

import Carregando from '../../components/Carregando/Carregando';

const FormCadastrarOutrosProdutos = () => {
    const navigate = useNavigate();
    const userData = JSON.parse(sessionStorage.getItem('userData'));

    const [carregando, setCarregando] = useState(false);    
    
    const [funcionarios, setFuncionarios] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [formData, setFormData] = useState({
        idCategoria: "",
        nomeCategoria: "",
        nomeProduto: "",
        descricao: "",
        precoCompra: "",
        precoVenda: "",
        quantidade: "", 
        departamento: "",
        qtdMinimaEstoque: "",
        imagem: null,
    });

    useEffect(() => {
        setCarregando(true);
        console.log('Verificando status do usuário na sessão...');
        if (userData) {
            try {
                if (userData.statusUsuario === 'logado') {
                    console.log('Dados do usuário na sessão:', userData);
                    const idEstabelecimento = userData.dadosEstabelecimento.id;

                    console.log('Dados do estabelecimento: ');
                    console.log(userData.dadosEstabelecimento);

                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        idEstabelecimento: idEstabelecimento
                    }));
                    
                    // vamos buscar as categorias no mercadinho
                    fetchCategoriasDeProdutos();

                    setCarregando(false);                    

                } else {
                    console.log('Usuário não está logado, mantendo na área restrita.');
                    setCarregando(false);
                }
            } catch (error) {
                console.error('Erro ao parsear os dados de usuário:', error);
                setCarregando(false);
            }
        } else {
            console.log('Usuário NÃO está logado!');
            setCarregando(false);
        }
    }, [navigate]);


    const fetchCategoriasDeProdutos = async () => {
        setCarregando(true);
        try {
            const dados = await buscarCategoriasDeProdutos(userData);
            if (dados?.categorias) {
                console.log('*** categorias ***', dados.categorias);
                setCategorias(dados.categorias);
            }
            setCarregando(false);
        } catch (error) {
            console.error('Erro ao buscar dados do estabelecimento:', error);
            setCarregando(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData((prevData) => ({
          ...prevData,
          imagem: e.target.files[0],
        }));
      };
    

    const handleSubmit = async (e) => {
        setCarregando(true);
        console.log('entrou no handleSubmit...');
        e.preventDefault();
        try {
            const response = await cadastrarOutrosProdutos(formData);
            console.log('Produto cadastrado com sucesso:', response);
            alert('Produto cadastrado com sucesso!');
            // fetchFuncionariosDoEstabelecimento(); // Atualiza a lista após cadastro
            setCarregando(false);
            navigate('/meus-produtos');
        } catch (error) {
            console.error('Erro ao cadastrar produto:', error);
            const errorMessage = error.response?.data?.message || 'Erro ao cadastrar produto. Tente novamente.';
            alert(errorMessage);
            setCarregando(false);
        }
    };

    if (carregando) {
        return <Carregando />;
    }

    return (
        <div className="form-cadastrar-container">
            <TituloComponent />
            <form onSubmit={handleSubmit}>
                <h2 className="form-title">Cadastro de Outros Produtos</h2>


                <div className="box-dados">
                    {/* Exibe o nome do estabelecimento */}
                    <p className="texto-welcome">Você está em { userData.dadosEstabelecimento.nome }!</p>
                    {/* Botão de Logout */}
                    {/* <button className="welcome-btn" onClick={handleLogout}>Logout</button> */}
                </div>



                <div className="form-section">
                    <h3 className="section-title">Dados do Produto</h3>

                    <div className="form-group">
                        <label htmlFor="nomeCategoria">Categoria do Produto</label>
                        <select
                            id="nomeCategoria"
                            name="nomeCategoria"
                            className="form-control"
                            value={formData.nomeCategoria}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Selecione a categoria do Produto</option>
                            {categorias.map((categoria) => (
                                console.log('Categoria listada:' , categoria),
                                <option key={categoria.id} value={categoria.nome}>
                                    {categoria.nome}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="nomeProduto">Nome do Produto</label>
                        <input
                            type="text"
                            id="nomeProduto"
                            name="nomeProduto"
                            className="form-control"
                            placeholder="Digite o nome do Produto"
                            value={formData.nomeProduto}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="descricao">Descrição</label>
                        <textarea 
                            id="descricao" 
                            name="descricao" 
                            className="form-control" 
                            value={formData.descricao} 
                            onChange={handleChange}  
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="precoCompra">Preço compra R$</label>
                        <input
                            type="text"
                            id="precoCompra"
                            name="precoCompra"
                            className="form-control"
                            placeholder="Preço de compra"
                            value={formData.precoCompra}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="precoCompra">Preço venda R$</label>
                        <input
                            type="text"
                            id="precoVenda"
                            name="precoVenda"
                            className="form-control"
                            placeholder="Preço de venda"
                            value={formData.precoVenda}
                            onChange={handleChange}
                            
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="precoCompra">Quantidade</label>
                        <input
                            type="number"
                            id="quantidade"
                            name="quantidade"
                            className="form-control"
                            placeholder="Quantidade"
                            value={formData.quantidade}
                            onChange={handleChange}
                            
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="precoCompra">Qtd mínima estoque</label>
                        <input
                            type="number"
                            id="qtdMinimaEstoque"
                            name="qtdMinimaEstoque"
                            className="form-control"
                            placeholder="Qtd mínima estoque"
                            value={formData.qtdMinimaEstoque}
                            onChange={handleChange}
                            
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="precoCompra">Departamento</label>
                        <input
                            type="text"
                            id="departamento"
                            name="departamento"
                            className="form-control"
                            placeholder="Departamento"
                            value={formData.departamento}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="imagem">Imagem</label>
                        <input type="file" id="imagem" name="imagem" className="form-control" onChange={handleFileChange} />
                    </div>




                </div>

                <button type="submit" className="btn-primary">
                    Cadastrar
                </button>
            </form>

            {/* Espaço entre o botão e a tabela */}
            <div className="mt-4"></div>


            {/* Aqui vai entrar a listagem dos produtos  */}

        </div>
    );
};

export default FormCadastrarOutrosProdutos;
